function checkSelectSize() {
  let isSelected = true;
  document.querySelectorAll('input[name="filter.v.option.talla"]').forEach((el) => {
    if (el.checked === true) {
      isSelected = false;
    }
  });
  return isSelected;
}

function bindTallaAvailabilityOnce(el) {
  if (el.dataset.simorraAvailabilityBound === 'true') return;
  el.dataset.simorraAvailabilityBound = 'true';
  el.classList.add('e1active');
  el.addEventListener('change', () => {
    const status = checkSelectSize();
    const availability = document.querySelector('input[name="filter.v.availability"]');
    if (availability) availability.checked = !status;
  });
}

function bindAllTallaInputs() {
  document.querySelectorAll('input[name="filter.v.option.talla"]').forEach(bindTallaAvailabilityOnce);
}

document.addEventListener('DOMContentLoaded', () => {
  bindAllTallaInputs();

  const facetRoot =
    document.querySelector('facet-filters-form') ||
    document.querySelector('[id^="FacetFiltersForm"]') ||
    document.querySelector('.facets-vertical') ||
    document.body;

  const observer = new MutationObserver(() => bindAllTallaInputs());
  observer.observe(facetRoot, { childList: true, subtree: true });
});
